import axios from "axios";
import CommonToast from "./CommonToast";
import MemberPanelAuth from "./MemberPanelAuth";

class MemberAxios {
  constructor() {}

  // post axios body initialize
  axiosBody(
    url,
    payload,
    reqType = "post",
    isToast = true,
    is_form_data = false
  ) {
    // return promiss
    return new Promise((resolve, reject) => {
      let headers = {
        token: MemberPanelAuth?.getSessionData()?.token,
      };
      if (is_form_data == true) {
        headers = {
          "Content-Type": "multipart/form-data",
          ...headers,
        };
      }
      // db operation
      axios[reqType](url, reqType == "post" ? payload.data : { headers }, {
        headers,
      })
        .then(async (res) => {
          // if user's role or permission update then, we need to update session
          res.data?.token && MemberPanelAuth.setSession({ ...res.data });
          // send response
          resolve(res);
        })
        .catch((err) => {
          if (err.response?.status == 401) {
            // if 401 un-authorize
            MemberPanelAuth.logout();
          } else {
            // other all error
            isToast == true &&
              CommonToast.error(
                err?.response?.data?.message || "Something went wrong!"
              );
          }
          // send err
          reject(err);
        });
    });
  }

  // post request
  static post(url, payload) {
    return new MemberAxios().axiosBody(url, payload, "post", true);
  }

  // form post
  static formDataPost(url, payload) {
    return new MemberAxios().axiosBody(url, payload, "post", true, true);
  }

  // silent post request. it has no default error toast
  static silentPost(url, payload) {
    return new MemberAxios().axiosBody(url, payload, "post", false);
  }

  // get request
  static get(url) {
    return new MemberAxios().axiosBody(url, "", "get", false);
  }
}

export default MemberAxios;
